// extracted by mini-css-extract-plugin
module.exports = {"shareOptions":"ShareModal-module-share-options","headline":"ShareModal-module-headline"};